import { MinuteRange } from "Components/WorkingHours/types/MinuteRange";
import { DropAreaPoint } from "../types/DropAreaPoint";

export function getWeekDropAreaPoints(
	visibleMinutes: MinuteRange,
	workingMinutes: MinuteRange
) {
	const dropAreaPoints: DropAreaPoint[] = [
		{ minute: visibleMinutes.start },
		{ minute: visibleMinutes.end },
	];

	if (workingMinutes.start > visibleMinutes.start) {
		dropAreaPoints.push({ minute: workingMinutes.start });
	}

	if (workingMinutes.end < visibleMinutes.end) {
		dropAreaPoints.push({ minute: workingMinutes.end });
	}

	return dropAreaPoints;
}
